import React from 'react';
import { Card, Grid, Paper, Box, Typography, Divider, FormControl, Select, MenuItem } from '@mui/material';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTheme } from '@mui/material/styles';
import { tokens } from '../../theme';

export default function LocationHeader({ location = '', locations = [], onLocationChange, loading = false }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Card sx={{ p: { xs: 1, md: 1.6 }, borderRadius: 2, boxShadow: 'none' }}>
      <Grid container spacing={{ xs: 0.8, md: 1.4 }} alignItems="center">
        <Grid item xs={12} sm={7}>
          <Typography sx={{ fontSize: { xs: 16, md: 20 }, mb: { xs: 0.55, md: 0.9 }, fontWeight: 500 }}>เลือกสถานที่ (Location)</Typography>
          <Paper elevation={0} sx={{ borderRadius: 1.2, display: 'flex', alignItems: 'center', border: '1px solid #d7e0e6', overflow: 'hidden' }}>
            <HomeWorkOutlinedIcon sx={{ color: '#666', mr: 0.8, fontSize: { xs: 20, md: 22 } }} />
            <FormControl fullWidth>
              <Select
                value={location}
                displayEmpty
                disabled={loading || locations.length === 0}
                onChange={(event) => onLocationChange?.(event.target.value)}
                IconComponent={KeyboardArrowDownIcon}
                inputProps={{ 'aria-label': 'เลือกสถานที่' }}
                sx={{ '& fieldset': { border: 0 }, '& .MuiSelect-select': { py: { xs: 1.1, md: 1.45 }, fontWeight: 600 } }}
              >
                <MenuItem value="" disabled>{loading ? 'กำลังโหลด...' : 'เลือกสถานที่'}</MenuItem>
                {locations.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
              </Select>
            </FormControl>
          </Paper>
        </Grid>
        <Grid item xs="auto" sx={{ display: { xs: 'none', sm: 'block' } }}>
          <Divider orientation="vertical" flexItem sx={{ borderColor: '#dce4e8', minHeight: { xs: 74, md: 98 } }} />
        </Grid>
        <Grid item xs={12} sm>
          <Box sx={{ bgcolor: '#edf8fd', borderRadius: 1.2, px: { xs: 0.9, md: 1.8 }, py: { xs: 0.85, md: 1.15 }, display: 'flex', alignItems: 'center', gap: { xs: 0.8, md: 1.4 }, minHeight: { xs: 72, md: 92 } }}>
            <Box sx={{ width: { xs: 42, md: 66 }, height: { xs: 42, md: 66 }, borderRadius: '50%', bgcolor: colors.primary[500], display: 'grid', placeItems: 'center', color: '#fff', flexShrink: 0 }}>
              <StorefrontOutlinedIcon sx={{ fontSize: { xs: 24, md: 36 } }} />
            </Box>
            <Box>
              <Typography sx={{ fontSize: { xs: 16, md: 16 }, color: colors.primary[500], lineHeight: 1.1 }}>Current Location</Typography>
              <Typography sx={{ fontSize: { xs: 16, md: 20 }, fontWeight: 600, lineHeight: 1.15 }}>{location}</Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: 0.55, md: 0.8 }, mt: { xs: 0.1, md: 0 } }}>
              <Typography sx={{ fontSize: { xs: 16, md: 16 }, color: '#111' }}>{location ? 'พร้อมสแกน' : 'กรุณาเลือกสถานที่'}</Typography>
                <Box sx={{ width: { xs: 9, md: 14 }, height: { xs: 9, md: 14 }, borderRadius: '50%', bgcolor: location ? '#25c91a' : '#f4a000' }} />
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
}
